import fetch from 'lib/fetch'

export function trackTimeTillInteractive(page) {
  const duration = window.performance.now()

  if (window.performance.mark) {
    window.performance.mark('time_till_interactive')
    // https://www.w3.org/TR/user-timing/#ut-standard-mark-names
    window.performance.mark('mark_fully_loaded')
  }

  if (window.performance.measure) {
    window.performance.measure('time_till_interactive')
  }

  fetch('/api/stats/tti', {
    method: 'POST',
    body: JSON.stringify({ duration, page })
  })
}



// WEBPACK FOOTER //
// ./lib/utils/stats.js